export default "__VITE_ASSET__BBHlk4$I__"